import { ThemeUICSSObject } from '@apia/theme';

export const messages: ThemeUICSSObject = {
  '& .listbox__list.messages__listbox': {
    listStyle: 'square',
    ml: '16px',

    '.listbox__row': {
      overflow: 'visible',
      whiteSpace: 'break-spaces',
      div: {
        alignItems: 'baseline',
        display: 'flex',
        gap: 3,
        justifyContent: 'space-between',
        p: 2,

        ':hover': {
          '.icon': {
            opacity: 1,
          },
        },

        '.icon': {
          opacity: 0,
          transition: 'opacity 0.3s',
          color: 'palette.text.primary',
        },

        '.icon__wrapper': {
          flexShrink: 0,
        },
      },
    },
  },

  '.separator': {
    listStyle: 'none',
  },

  '.messages__missingSections': {
    pt: 3,
    mt: 3,
  },
};
